import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TagModel } from '../../models/tag/tag.model';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../services/controls/shive-notification.service';
import * as fromTagsActions from './tags.actions';

@Injectable({
  providedIn: 'root',
})
export class TagsHttpService {
  private readonly store = inject(Store);
  private readonly shiveNotificationService = inject(ShiveNotificationService);
  private readonly actions$ = inject(Actions);

  constructor() {
    this.handleHttpCallbacks();
  }

  public getTags(): Observable<readonly TagModel[]> {
    this.store.dispatch(fromTagsActions.fetchTagList());

    return this.actions$.pipe(
      ofType(fromTagsActions.setTagList),
      map((result) => result.payload),
    );
  }

  public createTag(tagModel: TagModel): Observable<TagModel> {
    this.store.dispatch(
      fromTagsActions.createTag({
        payload: tagModel,
      }),
    );

    return this.actions$.pipe(ofType(fromTagsActions.tagCreated));
  }

  public updateTag(tagModel: TagModel): Observable<TagModel> {
    this.store.dispatch(
      fromTagsActions.updateTag({
        payload: tagModel,
      }),
    );

    return this.actions$.pipe(ofType(fromTagsActions.tagUpdated));
  }

  public deleteTag(toBeDeleted: TagModel | TagModel[]): Observable<TagModel> {
    this.store.dispatch(
      fromTagsActions.deleteTag({
        payload: toBeDeleted,
      }),
    );

    return this.actions$.pipe(ofType(fromTagsActions.tagDeleted));
  }

  private handleHttpCallbacks(): void {
    this.actions$
      .pipe(
        ofType(fromTagsActions.tagCreated, fromTagsActions.tagUpdated, fromTagsActions.tagDeleted),
      )
      .subscribe(() => {
        this.shiveNotificationService.show(NotificationType.Success);
      });
  }
}
